import { iconAtlas, iconMapping } from 'src/generated/icon-atlas'

interface IconMappingEntry {
  x: number
  y: number
  width: number
  height: number
  anchorX: number
  anchorY: number
  mask: boolean
}

export function useIconAtlas(): {
  iconAtlas: string
  iconMapping: Record<string, IconMappingEntry>
  isLoading: boolean
} {
  // Simply return the imported values
  return {
    iconAtlas,
    iconMapping,
    isLoading: false
  }
}
